import { gql } from "graphql-tag";

// Example: query books with nested images
export const listBooksWithImages = gql`
  query ListBooksWithImages {
    listBooks {
      items {
        id
        title
        authorName
        createdAt
        images {
          items {
            id
            key
            type
          }
        }
      }
    }
  }
`;
